// Configurazione centrale del menu laterale e helper di permessi (RBAC).
// Ogni voce ha un "key" (usato per role_menu), un "action" (catalogo RBAC)
// e un "page" (usato per i guard di rotta in App.js).

import { createMenuHelpers } from './kernelMenu';
import { getProjectMenu } from './projectMenu';

export const MENU = [
  {
    key: 'main',
    labelKey: 'nav.sectionMain',
    items: [
      { key: 'dashboard', page: 'dashboard', path: '/dashboard', labelKey: 'nav.dashboard', icon: 'home', action: 'dashboard.view', end: true },
      { key: 'profile', page: 'profile', path: '/profile', labelKey: 'nav.profile', icon: 'settings', end: true },
      { key: 'claude', page: 'claude', path: '/claude', labelKey: 'nav.claude', icon: 'sparkle', action: 'claude.use', end: true },
    ],
  },
  {
    key: 'projects-area',
    labelKey: 'nav.sectionProjects',
    items: [
      { key: 'projects', page: 'projects', path: '/projects', labelKey: 'nav.projects', icon: 'briefcase', action: 'projects.manage', end: true },
      { key: 'meetings', page: 'meetings', path: '/meetings', labelKey: 'nav.meetings', icon: 'mic', action: 'meetings.manage' },
    ],
  },
  {
    key: 'tickets-area',
    labelKey: 'nav.sectionTickets',
    items: [
      { key: 'tickets', page: 'tickets', path: '/tickets', labelKey: 'nav.tickets', icon: 'ticket', action: ['tickets.manage_own', 'tickets.manage_all', 'tickets.manage_assigned'] },
      { key: 'customers', page: 'customers', path: '/customers', labelKey: 'nav.customers', icon: 'user', action: 'customers.view', end: true },
      { key: 'ticket-projects', page: 'ticket-projects', path: '/ticket-projects', labelKey: 'nav.ticketProjects', icon: 'folder', action: 'ticket_projects.manage', end: true },
      { key: 'reports', page: 'reports', path: '/reports', labelKey: 'nav.reports', icon: 'table', action: ['tickets.manage_own', 'tickets.manage_all', 'tickets.manage_assigned'], end: true },
      { key: 'canned', page: 'canned', path: '/canned-responses', labelKey: 'nav.canned', icon: 'chat', action: 'ticket_projects.manage', end: true },
      { key: 'automations', page: 'automations', path: '/automations', labelKey: 'nav.automations', icon: 'zap', action: 'automations.manage', end: true },
    ],
  },
  {
    key: 'admin',
    labelKey: 'nav.sectionAdmin',
    items: [
      { key: 'admin', page: 'admin', path: '/admin', labelKey: 'nav.users', icon: 'users', action: 'users.manage', end: true },
      { key: 'permissions', page: 'permissions', path: '/permissions', labelKey: 'nav.permissions', icon: 'shield', action: 'roles.manage', end: true },
      { key: 'menu-config', page: 'menu-config', path: '/menu-config', labelKey: 'nav.menuConfig', icon: 'menu', action: 'roles.manage', end: true },
      { key: 'companies', page: 'companies', path: '/companies', labelKey: 'nav.companies', icon: 'company', action: 'companies.manage', end: true },
      { key: 'audit', page: 'audit', path: '/audit', labelKey: 'nav.audit', icon: 'audit', action: 'audit.view', end: true },
    ],
  },
];

// Azione richiesta per accedere a ciascuna pagina (guard di rotta).
export const PAGE_ACTIONS = {
  dashboard: 'dashboard.view',
  tickets: ['tickets.manage_own', 'tickets.manage_all', 'tickets.manage_assigned'],
  customers: 'customers.view',
  projects: 'projects.manage',
  meetings: 'meetings.manage',
  'ticket-projects': 'ticket_projects.manage',
  automations: 'automations.manage',
  claude: 'claude.use',
  canned: 'ticket_projects.manage',
  reports: ['tickets.manage_own', 'tickets.manage_all', 'tickets.manage_assigned'],
  profile: null,
  admin: 'users.manage',
  permissions: 'roles.manage',
  'menu-config': 'roles.manage',
  companies: 'companies.manage',
  audit: 'audit.view',
};

// Percorso di default per ogni pagina (usato dai redirect).
export const PAGE_PATH = {
  dashboard: '/dashboard',
  tickets: '/tickets',
  customers: '/customers',
  projects: '/projects',
  meetings: '/meetings',
  'ticket-projects': '/ticket-projects',
  automations: '/automations',
  claude: '/claude',
  canned: '/canned-responses',
  reports: '/reports',
  profile: '/profile',
  admin: '/admin',
  permissions: '/permissions',
  'menu-config': '/menu-config',
  companies: '/companies',
  audit: '/audit',
};

export const { canAction, isMenuItemChecked, getVisibleSections, canAccessPage, getDefaultPath } =
  createMenuHelpers(MENU, PAGE_ACTIONS, PAGE_PATH);

// Sezioni della sidebar: come getVisibleSections, più una voce per ogni
// progetto sotto "Progetti" (prima i preferiti). Il nome
// comincia con uno spazio a larghezza zero perché il Layout lo passa a t(): così
// non coincide mai con una chiave di traduzione (e t() lo restituisce così com'è).
export const getSidebarSections = (user) => {
  const sections = getVisibleSections(user);
  const projects = getProjectMenu(user?.id);
  if (projects.length === 0 || !canAction(user, 'projects.manage')) return sections;
  const toItem = (p) => ({
    key: `project-${p.id}`,
    page: 'projects',
    path: `/projects/${p.id}`,
    labelKey: `\u200b${p.name}`,
    icon: p.icon ? `emoji:${p.icon}` : 'table',
    end: true,
    disabled: false,
  });
  // I preferiti vengono per primi, poi gli altri nell'ordine scelto.
  const ordered = [...projects.filter((p) => p.favorite), ...projects.filter((p) => !p.favorite)].map(toItem);
  const result = sections.map((section) => (
    section.key === 'projects-area' ? { ...section, items: [...section.items, ...ordered] } : section
  ));
  return result;
};
